import { useState, useContext, useEffect } from 'react'
import { DContext } from '../../../context/Datacontext'
import { FaBriefcase, FaBuilding } from "react-icons/fa6";
import { FaShieldAlt, FaLock } from "react-icons/fa";
import { IoMdPerson, IoIosEye, IoIosEyeOff } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import LoadingPage from '../../pages/Loading';
import { emailValidator, passwordValidator } from '../../../utils/validator';
import { fetchDeviceData } from '../../../utils/fetchDeviceData';


const Signin = () => {

    const { setIsAuth, setCurrentUser, BeURL, renderError, showAlert } = useContext(DContext)

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)

    const [emailError, setEmailError] = useState('')
    const [passwordError, setPasswordError] = useState('')
    const [signinError, setSigninError] = useState('')

    const [loading, setLoading] = useState(false)

    const contentChecks = [email, password]
    const validationChecks = [emailError, passwordError]

    const [fingerPrintId, setFingerPrintId] = useState(null)
    const [browserName, setBrowserName] = useState(null)
    const [ipAddress, setIpAddress] = useState(null)

    useEffect(() => {

        const fetchDeviceDetails = async () => {

            const deviceDetails = await fetchDeviceData()

            setFingerPrintId(deviceDetails.fingerPrintId)
            setBrowserName(deviceDetails.browserName)
            setIpAddress(deviceDetails.ipAddress)
        }

        fetchDeviceDetails()

        const interval = setInterval(async () => {
            fetchDeviceDetails()
        }, 15000)

        return () => {
            if (interval) clearInterval(interval)
        }
    }, [])

    const HandleSignin = async (e) => {

        setSigninError("")

        setLoading("")

        e.preventDefault()

        if (!fingerPrintId || !browserName || !ipAddress) {
            showAlert("Device data is not available! Kindly try again later or contact support team.")
            return
        }

        if (validationChecks.every(item => item === "") && contentChecks.every(item => item !== "")) {
            setLoading(true)
            fetch(`${BeURL}/signin`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",

                },
                credentials: "include",
                body: JSON.stringify({
                    email, password, fingerPrintId, browserName, ipAddress,
                })
            })
                .then(res => res.json())
                .then(data => {
                    setLoading(false)
                    if (data.success) {
                        localStorage.setItem('accessToken', data.accessToken || "")
                        setIsAuth(true)
                        setCurrentUser(data.user)
                        setEmail('')
                        setPassword('')
                        window.location.href = "/"
                    } else {
                        showAlert(data.message)
                        setSigninError(data.message)
                    }
                })
                .catch(err => {
                    setLoading(false)
                    console.log('Error in Sign:', err)
                    alert('Trouble in connecting to the Server! Please try again later.')
                })
        }
        if (!email) {
            setEmailError("Email is required!")
        }
        if (!password) {
            setPasswordError("Password is required!")
        }
        // if (!selectedRole) {
        //     setSigninError("Please select a role to proceed!")
        // }

    }

    const roles = [
        {
            icon: IoMdPerson,
            title: 'Job-Seeker'
        },
        {
            icon: FaBuilding,
            title: 'Employer'
        },
        {
            icon: FaShieldAlt,
            title: 'Admin'
        }
    ]

    useEffect(() => {
        setEmailError(emailValidator(email))
        setPasswordError(passwordValidator(password))
        setSigninError("")
    }, [email, password])

    const handleKeyDown = e => {
        if (e.key === "Enter") HandleSignin(e)
    }

    if (!fingerPrintId || !browserName || !ipAddress) {
        return <LoadingPage />
    }

    return (
        <div className='flex flex-wrap justify-center items-center min-h-[85vh]'>
            <div className='rounded-xl shadow-lg border border-slate-100 p-5 w-[96%] sm:w-8/12 md:w-2/6'>
                <FaBriefcase className='mx-auto text-5xl p-3 rounded-lg bg-secondary-500 text-white my-2' />
                <h2 className='my-2 font-semibold text-center'>Welcome Back</h2>
                <p className='my-2 text-slate-700 text-center'>Sign in to your account</p>

                {/* <p className='mt-2'>I am a</p>
                <div className='flex gap-1 my-2'>
                    {
                        roles.map((role, i) => (
                            <div onClick={() => setSelectedRole(role.title.toLowerCase())} className={`text-center p-3 rounded-lg flex-1 border cursor-pointer ${(role.title.toLowerCase() === selectedRole.toLowerCase()) ? 'border-blue-500 text-blue-700 bg-blue-50' : 'text-slate-700 bg-slate-50'}`} key={i}>
                                <role.icon className='mx-auto text-xl' />
                                <h4 className='mt-1 text-sm'>{role.title}</h4>
                            </div>
                        ))
                    }
                </div> */}
                <div className='my-2'>
                    <div className='my-3'>
                        <label className='text-[16px] font-medium text-slate-700' htmlFor='email'>Email Address</label>
                        <div className='mt-2 relative'>
                            <input value={email} onChange={e => setEmail(e.target.value)} className='w-full rounded-lg placeholder:text-gray-400 pl-8 h-full py-4  outline-primary-50 border-[1px]' type='email' id='email' placeholder='Enter your email'></input>
                            <MdEmail className='text-gray-400 absolute top-[50%] left-0 translate-x-[50%] translate-y-[-50%]' />
                        </div>
                        {emailError && email !== '' && renderError(emailError)}
                    </div>
                    <div className='my-3'>
                        <label className='text-[16px] font-medium text-slate-700' htmlFor='password'>Password</label>
                        <div className='mt-2 relative'>
                            <input value={password} onKeyDown={handleKeyDown} onChange={e => setPassword(e.target.value)} className='w-full rounded-lg placeholder:text-gray-400g px-8 h-full py-4 outline-primary-50 border-[1px]' type={showPassword ? 'text' : 'password'} id='password' placeholder='Enter your password'></input>
                            <FaLock className='text-gray-400 absolute top-[50%] left-0 translate-x-[50%] translate-y-[-50%]' />
                            {
                                showPassword ?
                                    <IoIosEyeOff className='text-gray-400 absolute top-[50%] right-0 translate-x-[-50%] translate-y-[-50%]' onClick={() => setShowPassword(!showPassword)} /> :
                                    <IoIosEye className='text-gray-400 absolute top-[50%] right-0 translate-x-[-50%] translate-y-[-50%]' onClick={() => setShowPassword(!showPassword)} />
                            }
                        </div>
                        {passwordError && email !== '' && renderError(passwordError)}
                    </div>
                    {/* <a className='text-blue-600 font-medium text-sm' href='/forgot-password'>Forgot Password?</a> */}
                    {signinError && renderError(signinError)}
                    <button className={`w-full py-2 text-white bg-primary-400 rounded-lg my-2 ${loading ? 'cursor-progress' : ((validationChecks.some(item => item !== "") || contentChecks.some(item => item === "")) ? 'cursor-not-allowed' : 'cursor-pointer')}`} disabled={validationChecks.some(item => item !== "") && contentChecks.some(item => item === "")} onClick={HandleSignin}>Sign In</button>


                    <div className="relative flex items-center text-gray-500 my-4">
                        <hr className="flex-grow border-t border-gray-300" />
                        <span className="px-3 bg-white">Or continue with</span>
                        <hr className="flex-grow border-t border-gray-300" />
                    </div>

                    <p>Don't have an account? <a className='text-blue-600 font-medium text-sm' >Please Contact Admin </a></p>

                </div>
            </div>
        </div>
    )

}

export default Signin